import React, { useEffect, useState } from 'react';
import { TextField, Paper, Toolbar, AppBar, Button, Typography, FormLabel, FormControl, FormControlLabel, Radio, InputLabel, MenuItem, Select, RadioGroup } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux'
import { setSubscriptionPopUp } from 'api/session';
import { useCreateSubscriptionMutation } from 'services/subscription';
import { setPrice, setDuration, setFrequency, setPlanName, setTrialPeriod, setOem, setSubscription } from 'api/subscription';
import { useUserDetailsQuery } from "services/user";
import { useParams } from "react-router-dom";
import { useSubscriptionDetailsQuery } from "services/subscription";

const SubscriptionPopUp = (props) => {


    const { userId } = useParams();
    const subscription = useSelector(state => state.subscription);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [disableButton, setDisableButton] = useState(true);
    const [createSubscription, { isLoading: isUpdating }] = useCreateSubscriptionMutation();
    const requestId = useSelector(state => state.user.requestId);
    const [edit, setEdit] = useState(false);
    const [priceId, setPriceId] = useState(null);

    useEffect(() => {
        if (subscription.planName.length > 0 && subscription.duration > 0 && subscription.frequency.length > 0 && subscription.price > 0) {
            setDisableButton(false)
        }
    }, [subscription])


    const onPriceChange = (event) => {
        dispatch(setPrice(event.target.value))
    }

    const onFrequencyChange = (event) => {
        dispatch(setFrequency(event.target.value));
    };

    const onDurationChange = (event) => {
        dispatch(setDuration(event.target.value));
    };

    const onPlanNameChange = (event) => {
        dispatch(setPlanName(event.target.value));
    };

    const onTrialPeriodChange = (event) => {
        dispatch(setTrialPeriod(event.target.value));
    };

    const oemHandleChange = (event) => {
        console.log(event.target.value)
        if (event.target.value === 'false') {
            dispatch(setOem(false));
        } else {
            dispatch(setOem(true));
        }

    }

    const { userDetails } = useUserDetailsQuery(
        {
            id: userId,
            requestId: requestId
        },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {}
            })
        }
    );

    const submitSubscription = () => {
        setLoading(true);
        setDisableButton(true);
        createSubscription({

            "price": subscription.price,
            "frequency": subscription.frequency,
            "planName": subscription.planName,
            "duration": subscription.duration,
            "trialPeriod": subscription.trialPeriod,
            "oem": subscription.oem,
            customerId: userDetails.id

        })
            .unwrap()
            .then(result => {
                console.log(result);

                setDisableButton(false);
                setLoading(false)
            })
            .catch(err => {
                setDisableButton(false);
                setLoading(false)
            })
    }


    const { subscriptionDetails } = useSubscriptionDetailsQuery({ priceId: priceId || userDetails.priceId },
        {
            skip: !userDetails.priceId,
            selectFromResult: ({ data }) => ({
                subscriptionDetails: data || {}
            })
        }
    );



    useEffect(() => {
        if (subscriptionDetails?.price?.id) {
            console.log(subscriptionDetails?.product?.name)

            setEdit(true);
            var data = {
                planName: subscriptionDetails?.product?.name || '',
                duration: subscriptionDetails?.price?.duration || 1,
                frequency: subscriptionDetails?.price?.recurring?.interval || '',
                trialPeriod: subscriptionDetails?.price?.recurring?.trial_period_days || 0,
                price: subscriptionDetails?.price?.unit_amount || 0,
                oem: subscriptionDetails?.price?.metadata?.oem === 'true' ? true : false
            }
            console.log(data)
            dispatch(setSubscription(data))
        }
    }, [subscriptionDetails])


    return (
        <React.Fragment>
            <AppBar position="sticky" elevation={0}
                sx={{
                    background: "#e0dcdcff!important",
                    color: "#000",
                    fontWeight: "bolder",
                    '&:hover': {
                        background: "#e0dcdcff!important"
                    }
                }}
            >
                <Toolbar>
                    <Typography variant="h6"
                        sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#000",
                            flexGrow: 1
                        }}
                    >Setup Subscription</Typography>
                    <Button
                        variant="contained"
                        sx={{
                            background: "#FE8200",
                            '&:hover': {
                                background: "#FE8200"
                            }
                        }}
                        onClick={() => {
                            dispatch(setSubscriptionPopUp(false));
                        }}
                    >Close</Button>
                </Toolbar>
            </AppBar>
            <Paper elevation={0} sx={{
                padding: "10px",
                minHeigth: "800px"
            }}>

                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Plan Name"
                    placeholder="Plan Name"
                    name="planName"
                    onChange={onPlanNameChange}
                    value={subscription.planName || ''}
                />
                <TextField
                    variant="outlined"
                    type="number"
                    fullWidth
                    margin="normal"
                    label="Duration"
                    placeholder="Duration"
                    name="duration"
                    onChange={onDurationChange}
                    value={subscription.duration || ''}
                />
                <FormControl fullWidth sx={{ marginTop: "10px" }}>
                    <InputLabel id="frequency">Payment Frequency</InputLabel>
                    <Select
                        labelId="frequency"
                        id="frequency"
                        value={subscription.frequency}
                        label="Frequency"
                        onChange={onFrequencyChange}
                    >

                        <MenuItem value={'month'}>Month</MenuItem>
                        <MenuItem value={'year'}>Year</MenuItem>

                    </Select>
                </FormControl>

                <TextField
                    variant="outlined"
                    type="number"
                    fullWidth
                    margin="normal"
                    label="Trial Period (in days)"
                    placeholder="Trial Period (in days)"
                    name="trialPeriod"
                    onChange={onTrialPeriodChange}
                    value={subscription.trialPeriod || 0}
                />

                <TextField
                    variant="outlined"
                    type="number"
                    fullWidth
                    margin="normal"
                    label="Plan Price"
                    placeholder="Plan Price"
                    name="price"
                    onChange={onPriceChange}
                    value={subscription.price || 0}
                />

                <FormControl fullWidth sx={{ marginTop: "10px" }}>
                    <FormLabel>OEM Feature:</FormLabel>
                    <RadioGroup name="oem"
                        value={subscription.oem}
                        onChange={oemHandleChange}>
                        <FormControlLabel value={true} control={<Radio />} label="Enable" />
                        <FormControlLabel value={false} control={<Radio />} label="Disable" />
                    </RadioGroup>
                </FormControl>



                {edit ?

                    <Button
                        color={"primary"}
                        sx={{
                            fontSize: "14px",
                            backgroundColor: "#ED6C02",
                            color: "#fff",
                            marginTop: "30px",
                            marginBottom: "10px",
                            "&:hover": {
                                backgroundColor: "#ED6C02",
                                color: "#fff"
                            },
                            "&:disabled": {
                                backgroundColor: "#939393de",
                                color: "#dfdcdcde"
                            }

                        }}
                        size={'large'}
                        fullWidth
                        onClick={(() => { })}
                        disabled={disableButton || loading}
                    >
                        {loading ? 'Please Wait...' : 'Edit'}
                    </Button>
                    :

                    <Button
                        color={"primary"}
                        sx={{
                            fontSize: "14px",
                            backgroundColor: "#ED6C02",
                            color: "#fff",
                            marginTop: "30px",
                            marginBottom: "10px",
                            "&:hover": {
                                backgroundColor: "#ED6C02",
                                color: "#fff"
                            },
                            "&:disabled": {
                                backgroundColor: "#939393de",
                                color: "#dfdcdcde"
                            }

                        }}
                        size={'large'}
                        fullWidth
                        onClick={(() => submitSubscription())}
                        disabled={disableButton || loading}
                    >
                        {loading ? 'Please Wait...' : 'Submit'}
                    </Button>}
            </Paper>
        </React.Fragment>

    )
}

export default SubscriptionPopUp;
